import React from 'react'

import Container from './styles'

function ResultStatus(props) {
  const { text, color, icon } = props
  return (
    <Container style={{ color, border: `1px solid ${color}` }}>
      {icon && icon}
      {text}
    </Container>
  )
}

export default ResultStatus
